// @ts-nocheck

/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';

import { KLCollectibleIds } from '../types/collectible';
import { KLBasketErrorCodes } from '../types/errorCode';
import { KLRounds } from '../types/round';

export const KLCollectibleLabelsByCollectibleId = {
  // Round 1
  [KLCollectibleIds.FISHING]: { roundLabel: 'Tribu Rouge', collectibleLabel: 'Pêche' },
  [KLCollectibleIds.FIRECAMP]: { roundLabel: 'Tribu Rouge', collectibleLabel: 'Feu' },
  [KLCollectibleIds.HUT]: { roundLabel: 'Tribu Rouge', collectibleLabel: 'Cabane' },
  [KLCollectibleIds.RICE]: { roundLabel: 'Tribu Rouge', collectibleLabel: 'Riz' },
  [KLCollectibleIds.WATER]: { roundLabel: 'Tribu Rouge', collectibleLabel: 'Eau potable' },

  // Round 2
  [KLCollectibleIds.DUO]: { roundLabel: 'Tribu Blanche', collectibleLabel: 'Binômes' },
  [KLCollectibleIds.SLOTH]: { roundLabel: 'Tribu Blanche', collectibleLabel: 'Paresseux' },
  [KLCollectibleIds.BAMBOOS]: { roundLabel: 'Tribu Blanche', collectibleLabel: 'Bambous' },
  [KLCollectibleIds.GRAND_BLUE]: { roundLabel: 'Tribu Rouge', collectibleLabel: 'Grand bleu' },
  [KLCollectibleIds.BALANCE]: { roundLabel: 'Tribu Rouge', collectibleLabel: 'Équilibre' },

  // Round 3
  [KLCollectibleIds.MARK]: { roundLabel: 'Orientation', collectibleLabel: 'Repère' },
  [KLCollectibleIds.TAG]: { roundLabel: 'Orientation', collectibleLabel: 'Balise' },
  [KLCollectibleIds.KNIFE]: { roundLabel: 'Orientation', collectibleLabel: 'Poignard' },

  // Comforts
  [KLCollectibleIds.PIZZA]: { collectibleLabel: 'Pizza', collectibleType: 'Confort' },
  [KLCollectibleIds.CHOCOLATE]: { collectibleLabel: 'Chocolat', collectibleType: 'Confort' },
  [KLCollectibleIds.HOTEL]: { collectibleLabel: 'Hotêl', collectibleType: 'Confort' },

  // Collars
  [KLCollectibleIds.COLLAR]: { collectibleLabel: 'Collier' },

  // Special case for orientation (due to rollbacks possibilities)
  [KLRounds.ORIENTATION]: { roundLabel: 'Orientation' },

  // Pole
  [KLRounds.POLE]: { roundLabel: 'Poteaux' },
};

export const KlComfortLabels = {
  [KLCollectibleIds.PIZZA]: { coefficient: 0.3, label: ' € de Freebets' },
  [KLCollectibleIds.CHOCOLATE]: { coefficient: 0.5, label: ' € de Freebets' },
  [KLCollectibleIds.HOTEL]: { coefficient: 1, label: ' € de Freebets' },
};

export const KLErrorLabelsByErrorCode = {
  [KLBasketErrorCodes.E_BADGE_PENDING]:
    "Le pari n'est pas éligible à Koh-Lanta car un pari est déjà en cours sur ce badge",
  [KLBasketErrorCodes.E_OP_NOT_RUNNING]: "Le pari n'est pas éligible à Koh-Lanta car l'opération n'est pas en cours",
  [KLBasketErrorCodes.E_USER_NOT_IN]:
    "Le pari n'est pas éligible à Koh-Lanta car tu n'as pas commencé l'aventure ou tu es éliminé",
  [KLBasketErrorCodes.E_BET_QUALIFY_FORBIDDEN]: `Le pari n'est pas éligible à Koh-Lanta car le pari "Qualification" est interdit`,
  [KLBasketErrorCodes.E_FREEBET_FORBIDDEN]: "Le pari n'est pas éligible à Koh-Lanta car les Freebets sont interdits",
  [KLBasketErrorCodes.E_SYSTEM_FORBIDDEN]:
    "Le pari n'est pas éligible à Koh-Lanta car les paris système sont interdits",
  [KLBasketErrorCodes.E_MATCH_PENDING]:
    "Le pari n'est pas éligible à Koh-Lanta car au moins un match est déjà présent dans un pari en cours Koh-Lanta",
  [KLBasketErrorCodes.E_MATCH_PENDING_ORIENTATION]:
    'Le pari n’est pas éligible à Koh-Lanta car 3 paris ont déjà été placés sur la zone en cours',
  [KLBasketErrorCodes.E_BADGE_WON]: "Le pari n'est pas éligible à Koh-Lanta car le badge est déjà gagné",
  [KLBasketErrorCodes.E_TOO_MANY_TRIES]:
    "Le pari n'est pas éligible à Koh-Lanta car toutes les tentatives possibles sont déjà placées pour cette phase",
  [KLBasketErrorCodes.E_START_DATE_OVER_48]:
    "Le pari n'est pas éligible à Koh-Lanta car au moins un match débute dans plus de 48h",
  [KLBasketErrorCodes.E_START_DATE_OVER_OPE]:
    "Le pari n'est pas éligible à Koh-Lanta car au moins un match débute après la fin de l'opération",
  [KLBasketErrorCodes.E_BETSLIP_NOT_ELIGIBLE]: "Le pari n'est pas éligible à Koh-Lanta",
  [KLBasketErrorCodes.E_INTERNAL_ERROR]: 'Erreur interne Koh-Lanta',
  default: 'Une erreur du service Koh-Lanta est survenue',
};

export const getKLRoundRulesConfig = (specifics) => ({
  [KLRounds.T_RED]: {
    title: 'Tribu Rouge',
    rules: [
      <>
        {`Remportez les 5 badges sans cumuler 6 voix contre vous et gagnez ${
          specifics?.stakeMultiplicator ?? 'x'
        } fois le montant de votre plus petite mise sur
        l’aventure en Freebets.`}
      </>,
      <>Trouvez des colliers pour vous protéger au conseil et gagnez des cadeaux lors des épreuves de confort.</>,
    ],
  },
  [KLRounds.T_WHITE]: {
    title: 'Tribu Blanche',
    rules: [
      <>
        {`Remportez les 5 badges sans cumuler 6 voix contre vous et gagnez ${
          specifics?.stakeMultiplicator ?? 'x'
        } fois le
        montant de votre plus petite mise sur l’aventure en Freebets.`}
      </>,
      <>Trouvez des colliers pour vous protéger au conseil et gagnez des cadeaux lors des épreuves de confort.</>,
    ],
  },
  [KLRounds.ORIENTATION]: {
    title: 'Orientation',
    rules: [
      <>
        {`Trouvez consécutivement un repère puis la balise et le poignard associés, et gagnez ${
          specifics?.stakeMultiplicator ?? 'x'
        } fois le montant de votre
        plus petite mise sur l’aventure en Freebets.`}
      </>,
      <>A chaque pari perdu, vous passez au repère suivant. Attention, il n’y a que 3 poignards en jeu.</>,
    ],
  },
  [KLRounds.POLE]: {
    title: 'Poteaux',
    rules: [
      <>Enchainez les paris gagnants afin de cumuler du temps (minutes gagnées = (cote - 1) x 60)</>,
      <>Attention, un pari perdu et c&apos;est la chute !</>,
      <>
        Barème: <br />- 1h = {specifics?.h1StakeMultiplicator ?? 'x'}
        <br />- 2h = {specifics?.h2StakeMultiplicator ?? 'x'}
        <br />- 4h = {specifics?.h4StakeMultiplicator ?? 'x'}
        <br />- 6h = {specifics?.h6StakeMultiplicator ?? 'x'}
      </>,
    ],
  },
});

export const KLCollectibleRuleByCollectibleId = {
  [KLCollectibleIds.FISHING]: {
    rule: (
      <>
        Pari <b>combiné</b>
      </>
    ),
    exception: '(hors Live)',
  },
  [KLCollectibleIds.HUT]: {
    rule: (
      <>
        Pari <b>simple MyMatch</b>
      </>
    ),
    exception: '(hors Live)',
  },
  [KLCollectibleIds.RICE]: {
    rule: (
      <>
        Pari <b>simple Live</b>
      </>
    ),
  },
  [KLCollectibleIds.WATER]: {
    rule: (
      <>
        Pari <b>simple</b>
      </>
    ),
    exception: '(hors Live)',
  },
  [KLCollectibleIds.BALANCE]: {
    rule: (
      <>
        Pari <b>simple MyMatch</b>
      </>
    ),
  },
  [KLCollectibleIds.GRAND_BLUE]: {
    rule: (
      <>
        Pari <b>simple Live</b>
      </>
    ),
  },
  [KLCollectibleIds.FIRECAMP]: {
    rule: (
      <>
        Pari <b>combiné Live</b>
      </>
    ),
  },
  [KLCollectibleIds.DUO]: {
    rule: (
      <>
        Pari <b>simple</b>
      </>
    ),
    exception: '(hors Live)',
  },
  [KLCollectibleIds.SLOTH]: {
    rule: (
      <>
        Pari <b>combiné</b>
      </>
    ),
    exception: '(hors Live)',
  },
  [KLCollectibleIds.BAMBOOS]: {
    rule: (
      <>
        Pari <b>combiné Live</b>
      </>
    ),
  },
};

export const getKLOrientationStepRulesByStepId = (minOdds: number) => ({
  [KLCollectibleIds.MARK]: [<>Remporter un pari avec une cote minimum de {minOdds ?? ''}</>],
  [KLCollectibleIds.TAG]: [
    <>Avoir trouvé le repère de cette zone</>,
    <>Remporter un pari avec une cote minimum de {minOdds ?? ''}</>,
  ],
  [KLCollectibleIds.KNIFE]: [
    <>Avoir trouvé le repère et la balise de cette zone</>,
    <>Remporter un pari avec une cote minimum de {minOdds ?? ''}</>,
  ],
});
